import { useQuery } from '@tanstack/react-query';
import type { BoardResponse } from '../services/api/board';
import { fetchBoardExternal } from '../services/api/externalBoard';

/**
 * Phase 57 Plan 57-02 — PORTAL-02
 *
 * TanStack Query hook for the portal "My requests" rail.
 *
 * Shares the ['board', projectId, 'external'] query key with useBoard so the
 * portal rail and the board toggle surface data from the same cache slot —
 * no duplicate network requests when both are mounted.
 */
export function usePortalRequests(projectId: string) {
  return useQuery<BoardResponse>({
    queryKey: ['board', projectId, 'external'],
    queryFn: () => fetchBoardExternal(projectId),
    enabled: Boolean(projectId),
    refetchInterval: 5000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
  });
}
